import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { Button, Form, Image } from 'react-bootstrap';

import { forgotPassword } from '../../store/actions/users';
import { errorHelper } from '../../utils/tools';

import '../../styles/style.css';
import '../../styles/tenantSetup.css';

import logo from '../../assets/logo.svg';

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: { email: '' },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Zadajte platný e-mail.')
                .required('Zadajte e-mail.')
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                await dispatch(forgotPassword(values)).unwrap();
                setSubmitted(true);
            } catch {
                // error displayed via toast
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <div className="onboarding-overlay">
            <div className="onboarding-left">
                <div className="onboarding-left-content">
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', flexWrap: 'wrap' }}>
                        <span style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#fff', fontWeight: 500, letterSpacing: '0.02em' }}>Evidencia odpadov</span>
                        <span style={{ background: 'rgba(99,179,237,0.15)', border: '1px solid rgba(99,179,237,0.4)', borderRadius: '20px', padding: '4px 14px', fontSize: '0.78rem', color: '#90cdf4', fontWeight: 500, letterSpacing: '0.02em' }}>PPWR</span>
                    </div>
                    <h2>Plný súlad s legislatívou.<br/>Jednoducho a efektívne.</h2>
                    <p>Komplexná platforma pre evidenciu odpadov aj reporting obalov podľa nariadenia PPWR – všetko na jednom mieste.</p>
                    <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0 0 0' }}>
                        {[
                            'Evidenčné listy a ohlasovanie odpadov',
                            'Správa skladov a tok odpadov',
                            'PPWR – evidencia a reporting obalov',
                            'Exporty a štatistiky pre úrady',
                        ].map((item, i) => (
                            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.88)' }}>
                                <span style={{ width: '20px', height: '20px', borderRadius: '50%', background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '0.65rem' }}>✓</span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="onboarding-right auth-right">
                <Image src={logo} style={{ height: '32px', width: 'auto', position: 'absolute', top: '32px', right: '48px' }} />

                <div className="auth-form-inner">
                    {submitted ? (
                        <>
                            <div className="mb-4">
                                <h1>Email odoslaný</h1>
                                <p style={{ color: '#718094' }}>
                                    Ak je e-mail zaregistrovaný, pošleme vám odkaz na obnovu hesla. Skontrolujte svoju schránku.
                                </p>
                            </div>
                            <p className="auth-register-hint">
                                <Link to="/account/login" className="auth-register-link">
                                    Späť na prihlásenie
                                </Link>
                            </p>
                        </>
                    ) : (
                        <>
                            <div className="mb-4">
                                <h1>Zabudnuté heslo</h1>
                                <p style={{ color: '#718094' }}>Zadajte e-mail vášho účtu a pošleme vám odkaz na obnovu hesla.</p>
                            </div>

                            <Form onSubmit={formik.handleSubmit}>
                                <Form.Group className="mb-3" controlId="forgotEmail">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control
                                        type="email"
                                        className="radius"
                                        placeholder="Zadajte váš e-mail:"
                                        {...formik.getFieldProps('email')}
                                        isInvalid={errorHelper(formik, 'email').error}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errorHelper(formik, 'email').helperText}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button
                                    variant="primary"
                                    type="submit"
                                    size="lg"
                                    className="full-width button-custom-large radius"
                                    disabled={loading}
                                >
                                    {loading ? 'Odosielam...' : 'Odoslať odkaz'}
                                </Button>
                            </Form>

                            <p className="auth-register-hint">
                                <Link to="/account/login" className="auth-register-link">
                                    Späť na prihlásenie
                                </Link>
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
